<mat-card [formGroup]="form()">
  <mat-card-title class="section-title">
    Description
  </mat-card-title>

  <mat-card-content class="card-content">
    <div class="row">
      <div class="col-md-4">
        <label class="form-label">{{displayNames["additionalInformationForEquipmentEN"]}}</label>
        <div class="full-width editor-wrapper-en">
          <div class="control-col">
            <angular-editor
              [id]="'additionalInformationForEquipmentEN'"
              formControlName="additionalInformationForEquipmentEN"
              [config]="configEN()">
            </angular-editor>
            <mat-error *ngIf="getErrorMessage('additionalInformationForEquipmentEN') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <label class="form-label">{{displayNames["additionalInformationForEquipmentRU"]}}</label>
        <div class="full-width editor-wrapper-ru">
          <div class="control-col">
            <angular-editor
              [id]="'additionalInformationForEquipmentRU'"
              formControlName="additionalInformationForEquipmentRU"
              [config]="configRU()">
            </angular-editor>
            <mat-error *ngIf="getErrorMessage('additionalInformationForEquipmentRU') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <label class="form-label">{{displayNames["additionalInformationForEquipmentKZ"]}}</label>
        <div class="full-width editor-wrapper-kz">
          <div class="control-col">
            <angular-editor
              [id]="'additionalInformationForEquipmentKZ'"
              formControlName="additionalInformationForEquipmentKZ"
              [config]="configKZ()">
            </angular-editor>
            <mat-error *ngIf="getErrorMessage('additionalInformationForEquipmentKZ') as errorMessage">{{ errorMessage }}</mat-error>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
